import DetailsGridColumns from '@components/shared/DetailsGridColumns';
import { PAYOUT_METHOD } from '@constant/steps';
import { TransferDetailsContext } from '@context/TransferDetailsContext';
import { formatDateWithTime } from '@helpers/Date';
import { Divider, Grid, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
	subtitle: {
		color: theme.text.tertiary,
		fontWeight: '700',
		fontSize: '0.75rem'
	},
	content: {
		color: theme.text.primary,
		fontWeight: '700',
		fontSize: '0.875rem'
	},
	currency: {
		color: theme.text.primary,
		fontWeight: '700',
		fontSize: '1rem'
	}
}));

const getOrderDetails = (details, t, classes) => {
	return [
		...(details?.orderId
			? [
					{
						subTitle: t('ORDER_NUMBER'),
						content: details?.orderId,
						subtitleClassName: classes.subtitle,
						contentClassName: classes.content
					}
				]
			: []),
		...(details?.createdAt
			? [
					{
						subTitle: t('DATE_CREATED'),
						content: formatDateWithTime(details.createdAt),
						subtitleClassName: classes.subtitle,
						contentClassName: classes.content
					}
				]
			: []),
		...(details?.transaction?.payoutMethod
			? [
					{
						subTitle: t('PAYOUT_METHOD'),
						content: PAYOUT_METHOD[details.transaction.payoutMethod.toUpperCase()],
						subtitleClassName: classes.subtitle,
						contentClassName: classes.content
					}
				]
			: [])
	];
};

const getReceiveAmount = (details, t, classes) => {
	return [
		...(details?.transaction?.toAmount && details?.transaction?.toCurrency
			? [
					{
						subTitle: t('RECIPIENT_GETS'),
						content: `${details.transaction.toAmount} ${details.transaction.toCurrency}`,
						subtitleClassName: classes.subtitle,
						contentClassName: classes.currency
					}
				]
			: [])
	];
};

const TransactionDetails = () => {
	const theme = useTheme();
	const { t } = useTranslation();
	const { classes } = useStyles();
	const { details }: any = useContext(TransferDetailsContext);

	return (
		<>
			<Grid container direction="column">
				<Grid item>
					<Typography variant="h6" pb="5px" color={theme.text.secondary} sx={{ fontSize: '0.75rem' }}>
						{t('TRANSACTION_DETAILS')}
					</Typography>
				</Grid>
				<Divider />
				<Grid item pt="16px" pb="16px">
					<Grid container direction="column" spacing={1}>
						<DetailsGridColumns data={getOrderDetails(details, t, classes)} />
					</Grid>
				</Grid>
				<Divider />
				<Grid item pt="16px" pb="32px">
					<Grid container direction="column">
						<DetailsGridColumns data={getReceiveAmount(details, t, classes)} />
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};

export default TransactionDetails;
